/* Stylesheet */

.nav_item {
  --min-height: 56px;
  --background: transparent;
  --color: #ffffff;
  --border-color: #3a4b64;

  .icon {
    height: 21px;
    width: 21px;
    color: #ffffff;
  }
}
